const Accordion = require(MODULES_PATH + '/accordion');

document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.benefit-accordion')) {
    new Accordion({
      selector: '.benefit-accordion', // Target the container of accordion items
      duration: 400,
      openOnInit: [],
    });

    function updateAccordionBackground() {
      document
        .querySelectorAll('.benefit-accordion .group-benefit-card')
        .forEach((card) => {
          if (
            card
              .querySelector('.accordion-body')
              .classList.contains('is-active')
          ) {
            card.classList.add('bg-nyct-green');
          } else {
            card.classList.remove('bg-nyct-green');
          }
        });
    }

    // Listen for clicks within the accordion container
    document
      .querySelector('.benefit-accordion')
      .addEventListener('click', function () {
        setTimeout(updateAccordionBackground, 450); // Adjust the delay to match the accordion transition
      });

    // Initial update on page load
    updateAccordionBackground();
  }
});

document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.therapist-filter-topic-accordion')) {
    new Accordion({
      selector: '.therapist-filter-topic-accordion', // Target the container of accordion items
      duration: 400,
      openOnInit: [],
    });

    function updateAccordionBackground() {
      document
        .querySelectorAll(
          '.therapist-filter-topic-accordion .group-benefit-card'
        )
        .forEach((card) => {
          if (
            card
              .querySelector('.accordion-body')
              .classList.contains('is-active')
          ) {
            card.classList.add('bg-nyct-green');
          } else {
            card.classList.remove('bg-nyct-green');
          }
        });
    }

    // Listen for clicks within the accordion container
    document
      .querySelector('.therapist-filter-topic-accordion')
      .addEventListener('click', function () {
        setTimeout(updateAccordionBackground, 450); // Adjust the delay to match the accordion transition
      });

    // Initial update on page load
    updateAccordionBackground();
  }
});

document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.workshop-accordion')) {
    new Accordion({
      selector: '.workshop-accordion', // Target the container of accordion items
      duration: 400,
      openOnInit: [],
    });

    function updateAccordionBackground() {
      document
        .querySelectorAll('.workshop-accordion .group-workshop-card')
        .forEach((card) => {
          if (
            card
              .querySelector('.accordion-body')
              .classList.contains('is-active')
          ) {
            card.classList.add('bg-nyct-white-bright');
          } else {
            card.classList.remove('bg-nyct-white-bright');
          }
        });
    }

    // Listen for clicks within the accordion container
    document
      .querySelector('.workshop-accordion')
      .addEventListener('click', function () {
        setTimeout(updateAccordionBackground, 450); // Adjust the delay to match the accordion transition
      });

    // Initial update on page load
    updateAccordionBackground();
  }
});

document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('.faqs-accordion')) {
    new Accordion({
      selector: '.faqs-accordion', // Target the container of accordion items
      duration: 400,
      openOnInit: [],
    });

    function updateAccordionBackground() {
      document
        .querySelectorAll('.faqs-accordion .group-faqs-card')
        .forEach((card) => {
          if (
            card
              .querySelector('.accordion-body')
              .classList.contains('is-active')
          ) {
            card.classList.add('bg-nyct-white-bright');
          } else {
            card.classList.remove('bg-nyct-white-bright');
          }
        });
    }

    // Listen for clicks within the accordion container
    document
      .querySelector('.faqs-accordion')
      .addEventListener('click', function () {
        setTimeout(updateAccordionBackground, 450); // Adjust the delay to match the accordion transition
      });

    // Initial update on page load
    updateAccordionBackground();
  }
});
